/**
 * Cloudflare Image Resizing Helper for Auxo CDN assets
 * Inserts /cdn-cgi/image/<options>/ on assets.auxodev.dk URLs
 */
export function getCdnImage(url, options = {}) {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('https://assets.auxodev.dk')) return url;
  if (url.includes('/cdn-cgi/image/')) return url;

  const { width = 1200, quality = 80, format = 'auto', height, fit } = options;
  const parts = [];
  if (width) parts.push(`width=${width}`);
  if (height) parts.push(`height=${height}`);
  if (fit) parts.push(`fit=${fit}`);
  if (quality) parts.push(`quality=${quality}`);
  if (format) parts.push(`format=${format}`);

  const optionsStr = parts.join(',');
  return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/${optionsStr}/`);
}
